import styled from 'styled-components';

export const PopUpContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 133;
  height: 100vh;
  width: 100vw;
  background: rgba(4, 4, 15, .5);
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow-y: auto;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.6s;
  display: ${(props) => (props.show ? 'flex;' : 'none;')};
  opacity: ${(props) => (props.show ? '1;' : '0;')};
  animation-name: fadeInOpacity;
`;

export const PopUpContainerOpened = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 133;
    height: 100vh;
    width: 100vw;
    background: rgba(4, 4, 15, .5);
    justify-content: center;
    align-items: center;
    flex-direction: column;
    overflow-y: auto;
`;

export const PopUpInnerContent = styled.div`
position: relative;
background-color: #fff;
padding: 45px 50px 50px;
width: 75%;
height: 65%;
max-width: 735px;
margin: 2vh 0;
text-align: center;
// padding: 27px 20px 20px;
// display: -ms-flexbox;
// display: flex;
// -ms-flex-direction: column;
// flex-direction: column;
// -ms-flex-pack: distribute;
// justify-content: space-around
`;

export const CloseButtonLink = styled.a`
top: 17px;
right: 14px;
cursor: pointer;
position: absolute;
`;
